export function getApiRoot() {
  const runtimeEnv =
    typeof window !== "undefined" && window.__ENV && typeof window.__ENV === "object"
      ? window.__ENV
      : {};
  const envBase = process.env.REACT_APP_API_BASE || runtimeEnv.REACT_APP_API_BASE || "";
  const envUrl = process.env.REACT_APP_API_URL || runtimeEnv.REACT_APP_API_URL || "";

  const host =
    (typeof window !== "undefined" && window.location && window.location.hostname) || "";
  const isLocal =
    /^localhost$/.test(host) ||
    /^127\.0\.0\.1$/.test(host) ||
    /^192\.168\./.test(host) ||
    /^10\./.test(host);

  const defaultBase = isLocal ? "http://localhost:5001" : "";
  return (envBase || envUrl || defaultBase).replace(/\/+$/, "");
}
